import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import TextareaAutosize from 'react-textarea-autosize';

interface IFormProps {
  id: number,
  setForEdit: any
  setClose: any
}
interface MyStates {
  ajaxLoaded: boolean,
  datas: object,
  main_image: string,
  gallery: object,
  spinner: string,
  file_temp: any
}
export default class EditPlace extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: false,
      datas: {},
      main_image: '',
      gallery: {},
      spinner: 'flex',
      file_temp: {}
    }
    if( this.props.id > 0 ){
      this.getData()
    }
  }

  private getData() {
    var ajax = new Ajax(window.location.origin+ '/reservatio/szallashelyek/get/' + this.props.id);
    ajax.doPost('new_place', true).then((response) => {
      if( response.status !== undefined && response.status === 'success'){
        this.setState({
          datas: response.datas,
          main_image: response.main_image,
          gallery: response.gallery,
          spinner: 'none'})
      } else {
        swal({
          title: "Hiba történt!",
          text: "A szállás nem található!",
          icon: "error",
        });
        this.props.setForEdit(0)
      }
    })
  }

  private handleSubmit(e){
    e.preventDefault();

    var ajax = new Ajax(window.location.origin+ '/reservatio/szallashelyek/update/' + this.props.id);
    ajax.doPost('edit_place', true).then((response) => {
      if( response.status !== undefined && response.status === 'success' ){
        swal({
          title: "Siker!",
          text: "A szállás módosítva!",
          icon: "success",
        });
      } else {
        swal({
          title: "Hiba történt!",
          text: "A szállás nem lett hozzáadva!",
          icon: "error",
        });
      }
    })
  }



  private uploadMainImage(input){
    input.persist()
    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(  window.location.origin + '/reservatio/szallashelyek/uploadMainImage/'+this.props.id );
      ajax.doUpload(input).then((response) => {
        input.target.value = ''
        this.setState({ main_image: response.image, spinner: 'none', })
      })
    })
  }

  private uploadGalleryImages(input){
    input.persist()
    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(  window.location.origin + '/reservatio/szallashelyek/uploadGalleryImages/'+this.props.id );
      ajax.doUpload(input).then((response) => {
        input.target.value = ''
        this.setState({ gallery: response, spinner: 'none', })
      })
    })
  }

  private removeGalleryItem(id){
    swal({
        title: "Biztos, hogy törli ezt a szálláshelyet a listáról?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {
          this.setState({
            spinner: 'flex'
          }, () => {
            var ajax = new Ajax(window.location.origin + '/reservatio/szallashelyek/deleteGalleryItem/'+id);
            ajax.doPost({}).then((response) => {
              this.setState({ gallery: response, spinner: 'none' })
            })
          })
        }
    });
  }

  private close(){
    this.props.setClose(true)
  }

  public render() {
    if( this.props.id > 0 ){
      let accessibility = this.state.datas['accessibility'] ?? ''
        let double_multiplier = this.state.datas['double_multiplier'] ?? ''
        let storey = this.state.datas['storey'] ?? ''

      return (
      <>
      <div className="box" key={"edit_" + this.props.id}>
        <div className="box-header">
          <h3 className="box-title">Szállás módosítása</h3>
          <button type="button" style={{marginTop:"-3px"}} onClick={() => this.close()} className="btn btn-xs pull-right btn-danger"><i className="fa fa-window-close"></i></button>
        </div>
        <div className="box-body" style={{position: 'relative'}}>
          <div className="spinner-fill" style={{display: this.state.spinner}}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          <form id="edit_place" onSubmit={(e) => this.handleSubmit(e)}>
            <div className="row">
              <div className="col-md-6 form-group">
                <input type="text" name="name" defaultValue={this.state.datas['name'] ?? ''} className="form-control" placeholder="Megnevezés" required />
              </div>
              <div className="col-md-6 form-group">
                <input type="text" name="code" defaultValue={this.state.datas['code'] ?? ''} className="form-control" placeholder="Kód" required />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 form-group">
                <TextareaAutosize name="description" className="form-control" placeholder="Leírás" defaultValue={this.state.datas['description'] ?? ''}/>

              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon height-34px">
                    Akadálymentesített
                  </span>
                  <span className="input-group-addon" key={"access_" + accessibility}>
                    <input type="checkbox" name="accessibility" defaultChecked={ accessibility == 'yes' ? true : false } />
                  </span>
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon width-100px">
                    Férőhely:
                  </span>
                  <input type="number" name="capacity" defaultValue={this.state.datas['capacity'] ?? ''} className="form-control" required />
                  <span className="input-group-addon bg-white">
                    ágy
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon">
                  Minimum foglalható:
                  </span>
                  <input type="number" name="minimum_nights" defaultValue={this.state.datas['minimum_nights'] ?? ''} className="form-control" required />
                  <span className="input-group-addon bg-white">
                  éj
                  </span>
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon width-100px">
                    Napidíj:
                  </span>
                  <input type="number" name="daily_price" defaultValue={this.state.datas['daily_price'] ?? ''} className="form-control" required />
                  <span className="input-group-addon bg-white">
                    Ft
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <div className="input-group" key={"access_" + (this.state.datas['status'] ?? '')}>
                  <span className="input-group-addon width-150px">
                    Státusz:
                  </span>
                  <select name="status" defaultValue={this.state.datas['status'] ?? ''} className="form-control">
                    <option value="active">Aktív</option>
                    <option value="inactive">Inaktív</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6 form-group">
                <div className="input-group" >
                  <span className="input-group-addon height-34px">
                    Kétszeres szorzó:
                  </span>
                  <span className="input-group-addon" key={"access_" + double_multiplier}>
                    <input type="checkbox" name="double_multiplier" defaultChecked={ double_multiplier == 'yes' ? true : false } />
                  </span>
                </div>
              </div>
                <div className="col-md-6 form-group">
                    <div className="input-group" key={"access_" + (this.state.datas['storey'] ?? '')}>
                  <span className="input-group-addon width-150px">
                    Szállás típus:
                  </span>
                    <select name="storey" defaultValue={this.state.datas['storey'] ?? ''} className="form-control">
                        <option value="downstairs">Földszint</option>
                        <option value="first_floor">1. emelet</option>
                        <option value="tent_site">Sátorhely</option>
                    </select>
                    </div>
                </div>
            </div>
              <div className="row">
                  <div className="col-md-6 form-group">
                      <div className="input-group">
                          <button className="btn btn-success btn-block">Mentés</button>
                      </div>
                  </div>
              </div>
          </form>
          <hr />
          <div className="row">
            <div className="col-md-12" key={"mainimage_" + this.state.main_image}>
              <div className="form-group">
                <label>Fő kép</label>
                <input type="file" className="form-control" onChange={(e) => {this.uploadMainImage(e)}} accept="image/png, image/jpeg" />
              </div>
              {
              this.state.main_image != '' && this.state.main_image != null ?
              <div className="form-group">
                <img src={'/' + this.state.main_image} />
              </div>
              :
              <>
              </>
              }
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-12" key={"mainimage_" + this.state.main_image}>
              <div className="form-group">
                <label>Galéria képek</label>
                <input type="file" className="form-control" onChange={(e) => {this.uploadGalleryImages(e)}} accept="image/png, image/jpeg" multiple />
              </div>
            </div>
          </div>
          <div className="row">
            {
            Object.keys(this.state.gallery).length > 0 ?
            <>
            {
              Object.keys(this.state.gallery).map((item) => {
                let img = this.state.gallery[item].image
                return (
                  <div className="col-md-4 " key={"gallery_" + this.state.gallery[item].id}>
                    <div className="gallery_item">
                      <img src={'/' + img} />
                      <button type="button" className="btn btn-danger btn-sm" title="Törlés" onClick={() => this.removeGalleryItem(this.state.gallery[item].id)}>x</button>
                    </div>
                  </div>
                )
              })
            }
            </>
            :
            <>
            </>
            }
          </div>
        </div>
      </div>
      </>)
    } else {
      return (<></>)
    }
  }
}